import React from 'react'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { bindActionCreators } from 'redux'
import * as fromGoals from '../actions'
import * as fromCareplan from '../../Careplan/actions'
import * as fromHelpers from '../helpers'
import { PatientContext } from '../../Patients/containers/AddPatientChannel'
import WeightTarget from '../components/WeightTarget'
import BloodGlucoseTarget from '../components/BloodGlucoseTarget'
import KidneyTarget from '../components/KidneyTarget'

const CreateGoalsForm = ({ disease, createCarePlan, saveGoals }) => (
  <PatientContext.Consumer>
    {context => (
      <form
        onSubmit={e => {
          e.preventDefault()
          const { elements } = e.currentTarget
          const createGoals = fromHelpers.createGoals
          let goals = []
          let measuresTypes = []
          let shouldSaveFrequencies = true
          if (context.state.disease === 'heartFailure') {
            goals = [
              ...goals,
              ...createGoals({
                verylow: elements.namedItem('bpm-verylow').value,
                low: elements.namedItem('bpm-low').value,
                high: elements.namedItem('bpm-high').value,
                veryhigh: elements.namedItem('bpm-veryhigh').value,
                frequency: elements.namedItem('heartRate-frequency').value,
                disease: context.state.disease,
                description: 'heartRate',
                code: '8867-4'
              }),
              ...createGoals({
                verylow: elements.namedItem('weight-verylow').value,
                low: elements.namedItem('weight-low').value,
                high: elements.namedItem('weight-high').value,
                veryhigh: elements.namedItem('weight-veryhigh').value,
                frequency: elements.namedItem('bodyWeight-frequency').value,
                disease: context.state.disease,
                description: 'bodyWeight',
                code: '29463-7'
              })
            ]
            measuresTypes = ['heartRate', 'bodyWeight']
          }
          if (
            context.state.disease === 'type1Diabetes' ||
            context.state.disease === 'type2Diabetes1Injection' ||
            context.state.disease === 'type2DiabetesOtherSchemas'
          ) {
            goals = [
              ...goals,
              ...createGoals({
                verylow: elements.namedItem('fasting-verylow').value,
                low: elements.namedItem('fasting-low').value,
                high: elements.namedItem('fasting-high').value,
                veryhigh: elements.namedItem('fasting-veryhigh').value,
                disease: context.state.disease,
                description: 'fasting',
                code: '10450-5'
              }),
              ...createGoals({
                verylow: elements.namedItem('midday-verylow').value,
                low: elements.namedItem('midday-low').value,
                high: elements.namedItem('midday-high').value,
                veryhigh: elements.namedItem('midday-veryhigh').value,
                disease: context.state.disease,
                description: 'midday',
                code: '25428-4'
              }),
              ...createGoals({
                verylow: elements.namedItem('evening-verylow').value,
                low: elements.namedItem('evening-low').value,
                high: elements.namedItem('evening-high').value,
                veryhigh: elements.namedItem('evening-veryhigh').value,
                disease: context.state.disease,
                description: 'evening',
                code: '25428-4'
              })
            ]
            shouldSaveFrequencies = false
            measuresTypes = ['fasting', 'midday', 'evening']
          }
          if (context.state.disease === 'kidneyFailure') {
            goals = [
              ...goals,
              ...createGoals({
                verylow: elements.namedItem('systolic-verylow').value,
                low: elements.namedItem('systolic-low').value,
                high: elements.namedItem('systolic-high').value,
                veryhigh: elements.namedItem('systolic-veryhigh').value,
                frequency: elements.namedItem('systolic-frequency').value,
                disease: context.state.disease,
                description: 'systolic',
                code: '8480-6'
              }),
              ...createGoals({
                verylow: elements.namedItem('diastolic-verylow').value,
                low: elements.namedItem('diastolic-low').value,
                high: elements.namedItem('diastolic-high').value,
                veryhigh: elements.namedItem('diastolic-veryhigh').value,
                frequency: elements.namedItem('diastolic-frequency').value,
                disease: context.state.disease,
                description: 'diastolic',
                code: '8462-4'
              })
            ]
            measuresTypes = ['systolic', 'diastolic']
          }

          const frequencies = shouldSaveFrequencies
            ? measuresTypes.map(type => ({
                measureType: type,
                timesPerWeek: elements.namedItem(`${type}-frequency`).value,
                morning: elements.namedItem(`${type}-morning`).checked,
                midday: elements.namedItem(`${type}-midday`).checked,
                evening: elements.namedItem(`${type}-evening`).checked,
                duration: elements.namedItem(`${type}-duration`).value,
                durationUnit: elements.namedItem(`${type}-duration-unit`).value,
                timeDelay: elements.namedItem(`${type}-timeDelay`).value,
                timeDelayUnit: elements.namedItem(`${type}-timeDelay-unit`)
                  .value,
                timeDelayComment: elements.namedItem(
                  `${type}-timeDelay-comment`
                ).value
              }))
            : []

          saveGoals({ goals, frequencies, measuresTypes })
        }}
      >
        {context.state.disease === 'heartFailure' && <WeightTarget />}
        {context.state.disease === 'type1Diabetes' && <BloodGlucoseTarget />}
        {context.state.disease === 'type2Diabetes1Injection' && (
          <BloodGlucoseTarget />
        )}
        {context.state.disease === 'type2DiabetesOtherSchemas' && (
          <BloodGlucoseTarget />
        )}
        {context.state.disease === 'kidneyFailure' && <KidneyTarget />}

        <button>
          <FormattedMessage id="submit" />
        </button>
      </form>
    )}
  </PatientContext.Consumer>
)

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      createCarePlan: fromCareplan.createCarePlan,
      saveGoals: fromGoals.createGoals
    },
    dispatch
  )
export default connect(
  null,
  mapDispatchToProps
)(CreateGoalsForm)



// WEBPACK FOOTER //
// ./src/Goal/containers/CreateGoalsForm.js